import React, { ReactNode } from 'react';

import { Flex, Stack, Text, UnstyledButton, createStyles } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface NavigationItemProps {
  id: string;
  title: string;
  description?: string;
  isActive?: boolean;
  onClick: (id: string) => void;
  icon: ReactNode;
}

const useStyles = createStyles((theme) => ({
  item: {
    width: '100%',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      background: theme.colors.gray[0]
    }
  },
  itemActive: {
    background: theme.colors.gray[0]
  },
  content: {
    flex: 1,
    overflow: 'hidden',
    marginLeft: '12px'
  },
  title: {
    fontWeight: 500,
    fontSize: '13px',
    color: theme.colors.dark[4]
  },
  description: {
    color: theme.colors.gray[6],
    fontSize: '11px'
  }
}));

export function NavigationItem({ id, title, description, isActive = false, onClick, icon }: NavigationItemProps) {
  const { t } = useTranslation();
  const { classes, cx } = useStyles();

  const onClickHandler = () => {
    onClick(id);
  };

  return (
    <UnstyledButton className={cx(classes.item, { [classes.itemActive]: isActive })} onClick={onClickHandler}>
      <Flex p="10px 16px">
        {icon}
        <Stack spacing={5} className={classes.content}>
          <Text className={classes.title} truncate>
            {title || t('EXTRACTED_CONTENT.NAVIGATION_ITEM.DEFAULT_TITLE')}
          </Text>
          <Text className={classes.description} truncate>
            {description || t('EXTRACTED_CONTENT.NAVIGATION_ITEM.DEFAULT_DESCRIPTION')}
          </Text>
        </Stack>
      </Flex>
    </UnstyledButton>
  );
}
